/**
 * Amplitude helpers for GG+ membership analytics.
 * Keeps event names + property shapes in one place (see GG_PLUS_PRODUCT_PLAN.md).
 */
import { logEvent } from './analytics';

function log(event, properties = {}) {
  logEvent(event, properties);
}

/** Membership page loaded (checkout or manage view). */
export function logGgPlusMembershipPageViewed({ source, view, level } = {}) {
  log('gg_plus_membership_page_viewed', {
    ...(source ? { source } : {}),
    ...(view ? { view } : {}),
    ...(level ? { level } : {}),
  });
}

/** User tapped an upsell CTA toward membership. */
export function logGgPlusUpgradeClicked({ source, plan_id } = {}) {
  log('gg_plus_upgrade_clicked', {
    ...(source ? { source } : {}),
    ...(plan_id != null ? { plan_id } : {}),
  });
}

/** User moved the pay-what-you-want slider. */
export function logGgPlusPriceSelected({ price, source } = {}) {
  log('gg_plus_price_selected', {
    price,
    ...(source ? { source } : {}),
  });
}

/** Stripe Checkout session created — user leaving app to pay. */
export function logGgPlusCheckoutStarted({ price, source, trial_eligible } = {}) {
  log('gg_plus_checkout_started', {
    price,
    ...(source ? { source } : {}),
    ...(trial_eligible != null ? { trial_eligible: !!trial_eligible } : {}),
  });
}

/** Checkout succeeded and entitlements show trial. */
export function logGgPlusTrialStarted({ price, source } = {}) {
  log('gg_plus_trial_started', {
    ...(price != null ? { price } : {}),
    ...(source ? { source } : {}),
  });
}

/** Checkout succeeded without trial (returning subscriber). */
export function logGgPlusSubscriptionStarted({ price, source } = {}) {
  log('gg_plus_subscription_started', {
    ...(price != null ? { price } : {}),
    ...(source ? { source } : {}),
  });
}

/** Manage action — portal PM update, reactivate, or hub link. */
export function logGgPlusManageClicked({ action, source } = {}) {
  log('gg_plus_manage_clicked', {
    ...(action ? { action } : {}),
    ...(source ? { source } : {}),
  });
}

/** User opened Stripe Portal cancel flow. */
export function logGgPlusCancelClicked({ source } = {}) {
  log('gg_plus_cancel_clicked', {
    ...(source ? { source } : {}),
  });
}

/** Generic GG+ upsell surface became visible (e.g. home dashboard card). */
export function logGgPlusFeatureGateViewed({ source, plan_id } = {}) {
  log('gg_plus_feature_gate_viewed', {
    ...(source ? { source } : {}),
    ...(plan_id != null ? { plan_id } : {}),
  });
}

/** Monthly gifts upsell gate visible (plan card, gifting setup, etc.). */
export function logGgPlusMonthlyGiftsGateViewed({ source, plan_id } = {}) {
  log('gg_plus_monthly_gifts_gate_viewed', {
    ...(source ? { source } : {}),
    ...(plan_id != null ? { plan_id } : {}),
  });
}

/** Gift matching upsell gate visible on plan page or direct URL block. */
export function logGgPlusGiftMatchingGateViewed({ source, plan_id } = {}) {
  log('gg_plus_gift_matching_gate_viewed', {
    ...(source ? { source } : {}),
    ...(plan_id != null ? { plan_id } : {}),
  });
}

/** past_due messaging shown — payment failed, features paused. */
export function logGgPlusPaymentIssueViewed({ source } = {}) {
  log('gg_plus_payment_issue_viewed', {
    ...(source ? { source } : {}),
  });
}
